<template>
  <div>
    <div class="dashed-line" />
    <div v-for="(ticket, index) in ticketsInfo" :key="index" class="main-wrapper">
      <div>
        <v-layout v-if="!$apollo.loading" class="info-wrapper" column>
          <v-flex class="header">
            <img :src="require('../../../public/assets/blue-logo.svg')" alt="logo" />
            <div class="order-num">{{ $t('order') }} #100{{ orderInfo.id }}-{{ index + 1 }}</div>
          </v-flex>
          <v-flex class="section title">
            <h1 class="grey-title">{{ $t('yourTicketTo') }}</h1>
            <h1>{{ eventInfo.eventTitle }}</h1>
          </v-flex>
          <v-flex class="section">
            <span class="basic-message">
              {{ $t('yourTicketLocation') }}
            </span>
            <div v-if="!eventInfo.organizerMessage" class="basic-message basic-message-bottom">
              {{ $t('coreEventTeam') }}
            </div>
          </v-flex>
          <v-flex v-if="eventInfo.organizerMessage" class="section">
            <div class="organizer-message">Poruka organizatora</div>
            <div class="organizer-message-content" v-html="eventInfo.organizerMessage" />
            <div class="basic-message basic-message-bottom">
              {{ $t('coreEventTeam') }}
            </div>
          </v-flex>
          <v-flex class="section">
            <h3 class="organizer">{{ $t('organizerSeller') }}</h3>
            <p class="organizer-name">
              {{ organization.legalName }}, {{ $t('vat') }}: {{ organization.OIB }},
              {{ $t('address') }}: {{ organization.address }}, {{ organization.postalCode }}
              {{ organization.city }}<br />
              {{ $t('organizer') }} {{ organization.VATObligor ? $t('is') : $t('isNot') }}
              {{ $t('ticketAsReceipt') }}
            </p>
            <h3 class="tos-title">{{ $t('useTerm') }}</h3>
            <p class="tos">
              {{ $t('ticketDescription') }}
            </p>
          </v-flex>
        </v-layout>
      </div>
      <div class="event-ticket">
        <pdf-ticket
          :print-design="false"
          :is-sold-online="true"
          :event-info="eventInfo"
          :fiscalisation-info="{}"
          :has-bottom-border="false"
          :organization="organization"
          :ticket-name="ticket.orderItem.name"
          :ticket-location="ticket.accreditation.ticketLocation"
          :qrcode="ticket.accreditation.qrcode"
          :ticket-price="ticket.orderItem.price"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import pdfTicket from './pdf-ticket.vue'
import { GET_ORDER_INFO_BY_UUID } from './../../graphql/order.graphql'
import i18next from 'i18next'

export default {
  components: {
    pdfTicket,
  },
  props: {
    orderUUID: String,
    purchaseIndex: String,
  },
  data() {
    return {
      orderInfo: {},
      eventInfo: {},
      sellerName: '',
      ticketsInfo: [],
      organization: null,
      fiscalisationInfo: {},
    }
  },
  beforeMount() {
    window.onafterprint = () => {
      window.close()
    }
  },
  destroyed() {
    window.onafterprint = null
  },
  methods: {
    formatDate(date, withHours = true) {
      return (
        moment(date)
          .tz('Europe/Zagreb')
          .format(`DD. MMMM YYYY.${withHours ? ' u HH:mm' : ''}`) + `${withHours ? ' sati' : ''}`
      )
    },
  },
  apollo: {
    getOrderInfoByUUID: {
      query: GET_ORDER_INFO_BY_UUID,
      variables() {
        return {
          uuid: this.orderUUID,
        }
      },
      async result({ data, loading }) {
        if (!loading) {
          const { getOrderInfoByUUID } = data
          this.orderInfo = getOrderInfoByUUID
          this.organization = getOrderInfoByUUID.event.organization
          this.ticketsInfo =
            this.purchaseIndex === 'all'
              ? this.orderInfo.purchases
              : [this.orderInfo.purchases[this.purchaseIndex]]

          const isSameDay = moment(this.orderInfo.event.from).isSame(
            moment(this.orderInfo.event.to),
            'day',
          )
          const { address1, city, country } = this.orderInfo.event.location
          const eventAddress = [address1, city, country]
            .filter(e => e != null && e != '')
            .join(', ')
          i18next.changeLanguage(this.organization.preferredLanguage == 'en' ? 'en' : 'hr')
          this.eventInfo = {
            eventTitle: this.orderInfo.event.title,
            eventAddress: eventAddress,
            eventDate: `${this.formatDate(this.orderInfo.event.from, true)}${
              !isSameDay ? ` - ${this.formatDate(this.orderInfo.event.to, false)}` : ''
            }`,
            organizerMessage: this.orderInfo.event.organizerMessage,
          }
        }
      },
    },
  },
}
</script>

<style scoped>
h1 {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 0.33333in;
  line-height: 120%;
  letter-spacing: -0.03em;
}

.dashed-line {
  height: 100vh;
  position: fixed;
  left: calc(210mm * 0.8);
  border: none;
  border-right: 0.5px dashed #979797;
  border-right-style: dashed !important;
  z-index: 10;
}

.organizer-message {
  color: #0277bd;
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 0;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-family: 'Raleway';
}

.main-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.info-wrapper {
  padding: 0.33333in 1.55555in 0 0.44444in;
}

h3 {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: normal;
  font-size: 0.10666 im;
  line-height: 120%;
  color: #666666;
}

.organizer-name {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: normal;
  font-size: 0.08333in;
  line-height: 120%;
  color: #979797;
}

.title {
  margin: 0.33333in 0;
  padding: 0 !important;
}

.basic-message-bottom {
  margin-bottom: 0.44444in;
  margin-top: 0.20833in;
}

.ticket-info h5 {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 0.11111in;
  line-height: 150%;
  color: #979797;
}

.grey-title {
  color: #979797;
}

.blue-title {
  color: #0277bd;
  padding-bottom: 0.13333in;
}

.section {
  flex: 1;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.13888in;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  line-height: 120%;
  text-align: right;
  color: #979797;
}

.header img {
  height: 0.33333in;
}

span {
  font-size: 1.313rem;
}

.basic-message {
  font-size: 10px;
  line-height: 150%;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  color: #333;
  padding: 0 !important;
  margin-right: 0.43056in;
}

.tos {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 0.08333in;
  line-height: 120%;
  color: #979797;
  padding-bottom: 0.44444in;
  margin-right: 0.43056in;
}

.tos-title {
  font-size: 0.11111in;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 0.11111in;
  line-height: 120%;
  color: #666666;
  margin-bottom: 0.02777in;
  margin-right: 0.43056in;
}

.organizer {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 0.11111in;
  line-height: 120%;
  color: #666666;
  margin-top: 0.44444in;
}

.organizer-message-content {
  margin-right: 0.43056in;
  font-weight: 400;
  font-size: 10px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  color: #333;
}

.card {
  display: inline-flex;
  flex-direction: row;
  padding: 0.22222in 0.13611in 0.22222in 0.33333in;
  /* border: 0.10666in solid #0277bd; */
  box-sizing: border-box;
  background-size: cover;
  width: 100vw;
  page-break-inside: avoid;
}

.card .card-right-section img:not(.qr-code) {
  height: 0.33333in;
  margin-right: 0.2075in;
}

.card .card-right-section .qr-code {
  height: 0.8in;
  width: 0.8in;
}

.card .card-right-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  margin-left: 0.55555in;
}

.card .card-left-section {
  width: 6.26389in;
}

.card .event-date {
  padding-bottom: 0.11111in;
}

.event-date {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 0.16666in;
  line-height: 150%;
  color: #333333;
}

.address {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 0.13888in;
  line-height: 150%;
  color: #666666;
}

.info-wrapper .content {
  padding-right: 0.43056in;
}

.card .address {
  padding-bottom: 0.26388in;
}

.card .ticket-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.order-num {
  margin-right: 20px;
}

.event-ticket {
  border-top: 0.5px dashed #979797;
}
</style>
